export default "__VITE_ASSET__CIVzzD0M__"